var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AboutBanner',{attrs:{"imageList":this.config.banner_top.imageList}}),_c('Title'),_c('AboutOverview'),_c('AboutShopping'),_c('AboutShoppingList'),_c('Target'),_c('MileStore'),_c('FutureGoals'),_c('AboutBanner3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }